import { checkBeforeEnter } from '@/auth/utils';

export default [
	{
		path: '/controladores/desempenos',
		name: 'verifiers-performances-list',
		component: () => import('@/views/modules/verifiers/performances/performances-list/PerformancesList.vue'),
		beforeEnter: (to, from, next) => { checkBeforeEnter(['isVerifier'], to, from, next) },
		meta: {
			resource: 'ACL',
			pageTitle: 'Evaluaciones',
			breadcrumb: [{
				text: 'Lista de Evaluaciones de Desempeño',
				active: true
			}],
			requiresAuth: true
		}
	},
    {
		path: '/controladores/desempenos/evaluar/:id',
		name: 'verifiers-performances-evaluate',
		component: () => import('@/views/modules/verifiers/performances/performances-evaluate/PerformancesEvaluate.vue'),
		beforeEnter: (to, from, next) => { checkBeforeEnter(['isVerifier'], to, from, next) },
		meta: {
			resource: 'ACL',
			pageTitle: 'Evaluación',
			breadcrumb: [
				{
					text: 'Lista de Evaluaciones de Desempeño',
					to: {
						name: 'verifiers-performances-list',
					}
				},{
					text: 'Evaluar EDD',
					active: true
				}
			],
			requiresAuth: true
		}
	},
]